import {
  TechnicianAppointmentsQuery,
  TechnicianAppointmentsResult,
} from "@myapp/contract";
import { useQuery } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { appointmentApi } from "../service";

export function useTechnicianAppointments(query: TechnicianAppointmentsQuery) {
  return useQuery({
    queryKey: appointmentKeys.list(query),
    queryFn: async () => {
      const { data } = await appointmentApi.getByTechnicians(query);
      return data as TechnicianAppointmentsResult;
    },
    placeholderData: (prev) => prev,
  });
}
